import z from "zod";
import { OrgKeyCategory } from "../../generated/core-api";

export const ThreadInitStateSchema = z.object({
  initialKnowledgeFromOrgs: z.array(
    z.object({
      id: z.string(),
      category: z.nativeEnum(OrgKeyCategory),
    })
  ),
  userIntent: z.string(),
});
export type ThreadInitState = z.infer<typeof ThreadInitStateSchema>;
